var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyPolicyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 1.51318V4.26688C8.33317 4.64025 8.33317 4.82693 8.40583 4.96954C8.46975 5.09498 8.57173 5.19697 8.69718 5.26088C8.83978 5.33354 9.02647 5.33354 9.39984 5.33354H12.1535M8.33317 11.3335H4.33317M9.6665 8.66683H4.33317M12.3332 6.65898V11.4668C12.3332 12.5869 12.3332 13.147 12.1152 13.5748C11.9234 13.9511 11.6175 14.2571 11.2412 14.4488C10.8133 14.6668 10.2533 14.6668 9.13317 14.6668H4.8665C3.7464 14.6668 3.18635 14.6668 2.75852 14.4488C2.3822 14.2571 2.07624 13.9511 1.88449 13.5748C1.6665 13.147 1.6665 12.5869 1.6665 11.4668V4.5335C1.6665 3.41339 1.6665 2.85334 1.88449 2.42552C2.07624 2.04919 2.3822 1.74323 2.75852 1.55148C3.18635 1.3335 3.7464 1.3335 4.8665 1.3335H7.00769C7.49687 1.3335 7.74146 1.3335 7.97163 1.38876C8.17571 1.43775 8.3708 1.51856 8.54974 1.62822C8.75157 1.7519 8.92453 1.92485 9.27043 2.27075L11.3959 4.39624C11.7418 4.74214 11.9148 4.91509 12.0385 5.11693C12.1481 5.29587 12.2289 5.49096 12.2779 5.69503C12.3332 5.92521 12.3332 6.1698 12.3332 6.65898Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyIcon);
export default __webpack_public_path__ + "static/media/privacy_policy_icon.52b7c0c6ce740cb17e03d75ecfefcf19.svg";
export { ForwardRef as ReactComponent };